import React from 'react';
import SEO from '../../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './EmailMarketingHealthcare.css';

const EmailMarketingHealthcare = () => {
    const healthcareEmailServices = [
        {
            id: 'appointment-reminders',
            icon: '📅',
            title: 'Appointment Reminders',
            description: 'Automated appointment reminders to reduce no-shows and improve patient attendance rates.',
            link: '/services/email-marketing'
        },
        {
            id: 'health-education',
            icon: '📚',
            title: 'Health Education Content',
            description: 'Educational email campaigns that provide value to patients and position your practice as a trusted resource.',
            link: '/services/email-marketing'
        },
        {
            id: 'patient-retention',
            icon: '🔄',
            title: 'Patient Retention Automation',
            description: 'Automated follow-up sequences to keep patients engaged and encourage regular visits.',
            link: '/services/email-marketing'
        },
        {
            id: 'wellness-programs',
            icon: '💪',
            title: 'Wellness Program Emails',
            description: 'Promote wellness programs, preventive care, and health screenings to your patient base.',
            link: '/services/email-marketing'
        }
    ];

    return (
        <div className="seo-services-page">
            <SEO 
                title="Email Marketing Healthcare Services | Digi Network" 
                description="Learn more about our Email Marketing Healthcare services to grow your business online with Digi Network." 
                canonical="/industries/healthcare/services/emailmarketinghealthcare" 
            />

            {/* Hero Section */}
            <section className="seo-hero">
                <div className="seo-hero-bg"></div>
                <div className="container">
                    <div className="seo-hero-content">
                        
                        <h1>Email Marketing Services for Healthcare Practices</h1>
                        <p className="industry-service-hero-description">Nurture patient relationships with educational content, appointment reminders, and follow-up campaigns. Our healthcare-focused email marketing helps medical practices build lasting relationships with patients while maintaining HIPAA compliance.</p>
                        <div className="industry-service-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                            Get Free Email Audit
                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                            </svg>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Healthcare Email Marketing Services Grid */}
            <section className="seo-services-grid-section">
                <div className="container">
                    <h2>Our Healthcare Email Marketing Services</h2>
                    <p>HIPAA-compliant email marketing strategies designed specifically for healthcare practices</p>

                    <div className="seo-services-grid">
                        {healthcareEmailServices.map((service) => (
                            <Link to={service.link} key={service.id} className="seo-service-card">
                                <div className="seo-service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                                <div className="learn-more">
                                    Learn More
                                    <svg width="20" height="20" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="currentColor"/>
                                    </svg>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why Healthcare Email Marketing Matters */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="why-seo-content">
                        <div className="why-seo-text">
                            <h2>Why Email Marketing is Essential for Healthcare Practices</h2>
                            <div className="why-seo-points">
                                <div className="why-point">
                                    <h4>📅 Reduce No-Shows</h4>
                                    <p>Automated appointment reminders help reduce no-show rates and improve practice efficiency.</p>
                                </div>
                                <div className="why-point">
                                    <h4>📚 Patient Education</h4>
                                    <p>Educate patients about health topics and position your practice as a trusted healthcare resource.</p>
                                </div>
                                <div className="why-point">
                                    <h4>🔄 Patient Retention</h4>
                                    <p>Keep patients engaged between visits with regular communication and health tips.</p>
                                </div>
                                <div className="why-point">
                                    <h4>💡 Preventive Care</h4>
                                    <p>Promote preventive care services and wellness programs to improve patient health outcomes.</p>
                                </div>
                            </div>
                        </div>
                        <div className="why-seo-visual">
                            <div className="seo-visual-placeholder">
                                <p>🖼️ Add Healthcare Email Marketing Impact Graphic</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Process Section */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR APPROACH</div>
                        <h2>Our Email Marketing Process</h2>
                        <p>A proven methodology designed specifically for healthcare businesses</p>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Strategy & Planning</h3>
                            <p>Define your goals, audience segments, and email marketing roadmap.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Design & Content</h3>
                            <p>Create engaging email templates and compelling content that converts.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Automation Setup</h3>
                            <p>Build workflows that nurture leads and customers automatically.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Analyze & Improve</h3>
                            <p>Track performance metrics and continuously optimize for better results.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* Healthcare Email Marketing Process */}

            {/* CTA Section */}
            <section className="industry-service-cta">
                <div className="container">
                    <h2>Ready to Improve Patient Engagement with Email Marketing?</h2>
                    <p>Get a free email marketing audit and discover how we can help you build stronger relationships with your patients.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Your Free Email Audit
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default EmailMarketingHealthcare;
